module.exports = __webpack_public_path__ + "ui-static/img/logo-header_dark.44654595.svg";